import { gql } from '@apollo/client';

export interface ReplayRouteBrief {
    dspTaskId: number;
    routeName: string;
}

export interface ListReplayRoutesResponse {
    listReplayRoutes: ReplayRouteBrief[];
}

export interface ListReplayRoutesVariables {
    parentDspTaskId: number;
}

export const LIST_REPLAY_ROUTES = gql`
    query ListReplayRoutes($parentDspTaskId: Long!) {
        listReplayRoutes(parentDspTaskId: $parentDspTaskId) {
            dspTaskId
            routeName
        }
    }
`;
